import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
    AlertService,
    ButtonColors,
    ButtonModule,
    ButtonTypes,
    TextfieldModule,
} from '@ed---interne/ng-uui-components';
import { Organization } from '../../../../core/models/organization.model';
import { UpdateOrganization } from '../organization.state';
import { Observable } from 'rxjs';
import { OrganizationService } from '../organization.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

interface SettingsMenuItem {
    display: string;
    routerLink: any[];
    routerLinkActiveOptions?: any;
}

@UntilDestroy()
@Component({
    selector: 'organization-general',
    templateUrl: './organization-general.component.html',
    styleUrls: ['./organization-general.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        NgxTippyModule,
        ReactiveFormsModule,
        FormsModule,
        TextfieldModule,
        ButtonModule,
    ],
})
export class OrganizationGeneralComponent implements OnInit {
    public menuItems$: Observable<SettingsMenuItem[]> | undefined;
    public organizationId: string | null = null;
    public orgaFormGroup: FormGroup;
    public myOrga: Organization | undefined | null;
    public buttonColors = ButtonColors;
    public buttonTypes = ButtonTypes;
    public isSubmitting: boolean = false;

    constructor(
        private readonly alertService: AlertService,
        private readonly formBuilder: FormBuilder,
        private readonly store: Store,
        private organizationService: OrganizationService,
    ) {
        this.orgaFormGroup = this.formBuilder.group({
            name: [''],
            azureTenantId: [undefined],
        });
    }

    ngOnInit() {
        this.getInfoOrganization();
        // Observe changes form
        this.orgaFormGroup.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
            if (this.isSubmitting && this.orgaFormGroup.dirty) {
                this.isSubmitting = false;
            }
        });
    }

    public getInfoOrganization() {
        this.organizationService.organization$.subscribe((org) => {
            this.myOrga = org;
            this.orgaFormGroup.patchValue({
                name: this.myOrga?.name || '',
                azureTenantId: this.myOrga?.azureTenantId || undefined,
            });
        });
    }

    public onFileSelect(event: any): void {
        console.log(event);
    }

    public onSubmit(): void {
        if (this.isSubmitting) {
            return;
        }
        this.isSubmitting = true;

        const { name, azureTenantId } = this.orgaFormGroup.value;
        const orgaToUpdate: Partial<Organization> = {
            id: this.myOrga!.id,
            name,
            azureTenantId,
        };
        this.store
            .dispatch(new UpdateOrganization({ organizationPart: orgaToUpdate }))
            .pipe(untilDestroyed(this))
            .subscribe({
                next: () => {
                    this.myOrga!.name = name;
                    this.myOrga!.azureTenantId = azureTenantId;
                    this.organizationService.setOrganization(this.myOrga);
                    this.organizationService.triggerUpdateListOrga();
                    this.alertService.valid('Organisations', "L'organisation a bien été modifiée");
                    this.orgaFormGroup.markAsPristine();
                    this.isSubmitting = false;
                },
                error: (err) => {
                    this.alertService.error(
                        'Organisations',
                        "une erreur est survenue : Impossible de mettre à jour l'organisation",
                    );
                    this.isSubmitting = false;
                },
            });
    }

    public resetForm(): void {
        this.orgaFormGroup.reset();
        this.isSubmitting = false;
        this.getInfoOrganization();
    }
}
